import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => {
  return ({
    headerContainer: {
      margin: '24px 40px',
    },
    contentContainer: {
      margin: '0 20px',
      display: 'flex',
      flexWrap: 'wrap',
    },
    headingText: {
      color: '#141106',
      fontSize: '40px',
      fontWeight: 'bold'
    },
    subHeading: {
      color: '#141106',
      opacity: '0.6',
      margin: '30px 0 20px 0'
    },
    filter: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    fillerCards: {
      flex: '1 1 350px',
      height: 0,
      margin: '16px 24px',
      maxWidth: '500px',
      minWidth: '350px'
    }
  })
})

export { useStyles }
